import { type DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { CreateExtraAppForm } from "../CreateExtraAppForm";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { useExtraAppModal } from "../../hooks/use-extra-app-modal";
import styles from "./styles.module.css";
import { isValidUrl } from "../../helpers";
import { createNotification } from "../../../../app/state/notificationSlice/slice";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (id: TModalsIds) => void;
}

export const ExtraAppCreateModal = ({ closeModal }: Props) => {
  const dispatch = useAppDispatch();
  const manageExtraApp = useModalSelectors("manage_extra_app_modal");
  const {
    uri,
    title,
    tokenOn,
    handleSetForm,
    handleUpdateApp,
    handleCreateExtraAppObject,
  } = useExtraAppModal();
  const { t } = useTranslation();

  const handleCloseModal = () => {
    setTimeout(() => {
      closeModal("manage_extra_app_modal");
    }, 50);
  };

  const handleConfirmAction = () => {
    const isValidUri = isValidUrl(uri);
    if (!isValidUri) {
      dispatch(
        createNotification("warning", t("extra_app.invalid_url_message")),
      );
      return;
    }
    if (manageExtraApp.subtype === "create_extra_app") {
      handleCreateExtraAppObject();
    } else {
      handleUpdateApp();
    }

    handleCloseModal();
  };

  return (
    <ModalBasic
      open={manageExtraApp.isOpen}
      title={t("extra_app.modal_title")}
      hasFooter
      onOk={handleConfirmAction}
      buttonOkText={"Подтвердить"}
      onCancel={handleCloseModal}
      onClose={handleCloseModal}
      disabledOkBtn={uri === ""}
    >
      <CreateExtraAppForm
        uri={uri}
        title={title}
        tokenOn={tokenOn}
        handleSetForm={handleSetForm}
      />
    </ModalBasic>
  );
};
